import type { CoreClient, FoundationStatus } from '../contracts/foundation';

export interface InMemoryCoreClientOptions {
  readonly now?: () => Date;
}

export class InMemoryCoreClient implements CoreClient {
  readonly #now: () => Date;

  constructor(options: InMemoryCoreClientOptions = {}) {
    this.#now = options.now ?? (() => new Date());
  }

  async initialize(): Promise<FoundationStatus> {
    return Promise.resolve({
      contractVersion: '0.1',
      application: 'noemir-v01',
      version: '0.1.1',
      mode: 'memory',
      initializedAt: this.#now().toISOString(),
      adapters: {
        graph: 'ready',
        knowledge: 'ready',
        neural: 'ready',
        storage: 'ready',
      },
    });
  }
}
